import { DynamicPricingRuleData } from './dynamic-pricing-rule-data';

export interface CustomerLaneGroupPricingRuleData extends DynamicPricingRuleData {
  customerLaneGroupId: number;
}
